import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import ButtonBase from '../../../components/Buttons/ButtonBase';

const fields = [
    {
      name: 'currentPassword',
      label: 'Contraseña actual'
    },
    {
      name: 'newPassword',
      label: 'Nueva contraseña'
    },
    {
      name: 'confirmPassword',
      label: 'Confirmar nueva contraseña'
    },
];

const useStyles = makeStyles({
    IconButtonRoot: {
        color: '#c1c1c1',
        padding: 5
    }
});

const FormUpdatePasswordClient = props => {
    const classes = useStyles();
    const [showPassword, setShowPassword] = useState({
      currentPassword: false,
      newPassword: false,
      confirmPassword: false
    });
  
    const handleToggleShowPassword = name => event => {
      event.preventDefault();
      setShowPassword({
        ...showPassword,
        [name]: !showPassword[name]
      });
    };
  
    const {
      values,
      handleChange,
      handleBlur,
      handleSubmit,
      touched,
      errors,
      isValid
    } = props;
  
    return (
      <form onSubmit={handleSubmit}>
        {fields.map(({ name, label }) => {
          return (
            <div key={name}>
              <TextField
                id={name}
                name={name}
                label={label}
                value={values[name]}
                onChange={handleChange}
                onBlur={handleBlur}
                type={showPassword[name] ? 'text' : 'password'}
                helperText={touched[name] && errors[name] ? errors[name] : ''}
                error={touched[name] && errors[name] ? true : false}
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        classes={{
                          root: classes.IconButtonRoot
                        }}
                        aria-label="Toggle password visibility"
                        onClick={handleToggleShowPassword(name)}
                      >
                        {showPassword[name] ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </div>
          );
        })}
        <br />
        <ButtonBase
          type="submit"
          variant="primary"
          isValid={isValid}
        >
          Guardar Cambios
        </ButtonBase>
      </form>
    );
}

export default FormUpdatePasswordClient;